// Ch95 · PKT-0792 · an engine error, said to Grant rather than at him.
//
// The review card printed `item.errors[0]` verbatim, so a real card read:
//
//     PKG-SEAL: manifest does not match contents
//
// — an internal code first, in red, on the screen he reviews from. The packet's
// binding rule is "Words: plain, from Grant's side of the screen".
//
// 🔴 WHAT THIS DELIBERATELY DOES NOT DO: translate the codes.
//
// The code vocabulary lives in the box's engine, NOT in this repository — a
// search of the whole repo finds exactly one occurrence of `PKG-SEAL`, and it is
// a test fixture. Mapping codes to friendlier sentences would mean inventing
// meanings for strings I cannot enumerate and cannot check, and a confident
// wrong explanation of a broken package is worse than an honest opaque one.
//
// So this does the one thing that is safe without the vocabulary: it puts the
// ENGINE'S OWN WORDS first and demotes the CODE to a quiet second line, where it
// stays available for anyone diagnosing. Nothing is hidden and nothing is added.

export interface SplitError {
  /** The engine's own sentence, shown first. */
  message: string;
  /** The machine code, shown small and quiet — or null when there wasn't one. */
  code: string | null;
}

/**
 * A leading SCREAMING-KEBAB code followed by a colon, and nothing else.
 *
 * Anchored and bounded on purpose: `Rent: $1,800 is over budget` must NOT be
 * read as a code called "Rent". A code is upper-case, may carry digits, hyphens
 * or underscores, and is at least two characters.
 */
const CODE_RE = /^([A-Z][A-Z0-9_-]{1,39}):\s+(.*)$/s;

export function splitErrorCode(raw: string): SplitError {
  const text = (raw ?? "").trim();
  if (!text) return { message: "", code: null };

  const match = CODE_RE.exec(text);
  if (!match) return { message: text, code: null };

  const [, code, message] = match;
  // A code with no sentence after it is all we have; keep it as the message
  // rather than rendering an empty line with a quiet code under it.
  if (!message.trim()) return { message: text, code: null };

  return { message: message.trim(), code };
}
